module.exports = __webpack_public_path__ + "img/guandai_yj_wanglancai.cc1861ca.jpg";